"use client";

import { useEffect, useRef } from "react";
import Icon from "@/components/ui/AppIcon";

export default function CtaBanner() {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.remove("hidden");
        });
      },
      { threshold: 0.2 }
    );
    const reveals = ref?.current?.querySelectorAll(".reveal");
    reveals?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="py-24 px-6"
      style={{ background: "linear-gradient(135deg, #1A1A18 0%, #2A2A20 50%, #1A1A18 100%)" }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <div className="reveal hidden">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-amber mb-4">
            Visit Us In Store
          </p>
          <h2 className="font-heading text-5xl md:text-7xl font-black leading-none tracking-tight text-cream mb-6">
            Ready to Find
            <br />
            <span className="italic font-light text-amber">Your Ride?</span>
          </h2>
          <p className="text-white/50 text-lg max-w-xl mx-auto leading-relaxed mb-10">
            Visit our San Francisco showroom for a personalized bike fitting, test rides, and expert advice. No appointment needed.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a
              href="#bikes"
              className="btn-amber flex items-center justify-center gap-2 px-8 py-4 rounded-full text-base"
            >
              Shop Online
              <Icon name="ArrowRightIcon" size={18} className="text-charcoal" />
            </a>
            <a
              href="#"
              className="flex items-center justify-center gap-2 border-2 border-white/20 text-cream font-bold px-8 py-4 rounded-full text-base hover:border-amber hover:text-amber transition-all duration-300"
            >
              <Icon name="MapPinIcon" size={18} />
              Get Directions
            </a>
          </div>

          {/* Store info */}
          <div className="flex flex-wrap justify-center gap-8 text-sm text-white/40">
            <div className="flex items-center gap-2">
              <Icon name="MapPinIcon" size={16} className="text-amber" />
              <span>2847 Market St, San Francisco CA 94114</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="ClockIcon" size={16} className="text-amber" />
              <span>Mon–Sat 9am–7pm · Sun 10am–5pm</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="PhoneIcon" size={16} className="text-amber" />
              <span>(415) 555-0192</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}